import * as React from "react";
import styles from "./CustomerSatisfactionBanner.module.scss";

type CustomerSatisfactionBannerType = {
  percent?: string;
};

const CustomerSatisfactionBanner: React.FC<CustomerSatisfactionBannerType> = ({
  percent = "96%",
}) => (
  <div className={styles.container}>
    <div className={styles.flexContainer}>
      <h2 className={`primary--blue-text ${styles.heading}`}>{percent}</h2>
      <p className={`primary--grey-text ${styles.text}`}>
        practitioner
        <br />
        satisfaction
      </p>
    </div>
  </div>
);

export default CustomerSatisfactionBanner;
